import { Box, withStyles } from '@material-ui/core';
import { TextColor } from '@setvi/shared/enums';

const Dot = withStyles({
  root: {
    width: 12,
    height: 12,
    flexShrink: 0,
    borderRadius: '50%'
  }
})(Box);

interface ImagesNavigationProps {
  numberOfItems: number;
  activeItem: number;
  onChange: (newActive: number) => void;
}

export const ImagesNavigation = ({
  numberOfItems,
  activeItem,
  onChange
}: ImagesNavigationProps) => (
  <Box display="flex" alignItems="center" gridGap="4px">
    {Array.from(new Array(numberOfItems)).map((_, index) => {
      const isActive = activeItem === index;

      return (
        <Dot
          onClick={() => onChange(index)}
          style={{
            backgroundColor: isActive ? TextColor.SlateGrey : '#d9dee1'
          }}
        />
      );
    })}
  </Box>
);
